import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { t, use } from 'i18next';
import React from 'react'
import { useTranslation } from 'react-i18next';
export interface DeleteDialogProps {
    onDeleteAgree: (event: any) => void;
    onClose: (event: any) => void;
    open: boolean;
    data?: any;
}

export default function DeleteDialog(props: DeleteDialogProps) {
    const { onDeleteAgree, onClose, open, data } = props;
    const { t } = useTranslation();
    const handleClose = (e: any) => {
        onClose(e);
    };
    return (
        <Dialog
         sx={{ zIndex: 5002}}
            open={open}
            onClose={() => { handleClose(data) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t('reallyDelete') + "?"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('reallyDelete') + (data?.name ? ` ${data.name}` : '') + "?"}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { handleClose(data) }} autoFocus>{t('No').toUpperCase()}</Button>
                <Button onClick={() => { onDeleteAgree(data) }} >
                    {t('Yes').toUpperCase()}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
